import api from './client';
import { forEach, size } from 'constants/lodash';

export const uploadLayerData = (sectorId, layers) => {
  if (!size(layers)) return Promise.resolve();
  const requests = [];
  forEach(layers, (layer, id) => requests.push(api(`/resources/${sectorId}/layers/${id}`, { method: 'PUT', body: layer })));
  return Promise.all(requests);
};
export const createLayer = (sectorId, layer) => api(`/resources/${sectorId}/layers`, { method: 'POST', body: layer });
export const updateLayer = (sectorId, layerId, layer) => api(`/resources/${sectorId}/layers/${layerId}`, { method: 'PUT', body: layer });
export const updateLayers = (sectorId, layers) => Promise.all(Object.entries(layers).map(([id, layer]) => updateLayer(sectorId, id, layer)));
export const deleteLayer = (sectorId, layerId) => api(`/resources/${sectorId}/layers/${layerId}`, { method: 'DELETE' });
export const getLayerData = sectorId => api(`/sectors/${sectorId}`).then(({ layers }) => layers);
